// Rathern than type and comparison, this is an enum because it the enum items  don't need string values.
export enum SCOPE {
  ATTRIBUTES,
  SETS,
}
